"use client";

import { createContext, useContext } from "react";

import { FeatureFlags } from "@/generated/open-api/schemas";

export const FeatureFlagsContext = createContext<FeatureFlags>({ use_posa: false });

interface FeatureFlagsProviderProps {
  children: React.ReactNode;
  featureFlags: FeatureFlags;
}

export function FeatureFlagsProvider({ children, featureFlags }: FeatureFlagsProviderProps) {
  return (
    <FeatureFlagsContext.Provider value={featureFlags}>{children}</FeatureFlagsContext.Provider>
  );
}

export function useFeatureFlags() {
  const value = useContext(FeatureFlagsContext);
  if (value === undefined) {
    throw new Error("useFeatureFlags must be used within a FeatureFlagsProvider");
  }
  return value;
}

export function useFeatureFlag<K extends keyof FeatureFlags>(key: K) {
  const featureFlags = useFeatureFlags();
  return (featureFlags[key] ?? false) as FeatureFlags[K];
}
